/**
 * §notif-center — per-notification iconography. A small identity icon makes the
 * list scannable at a glance (you read the shape before the text). Mapped by
 * kind; severity drives the color via the --sev token in CSS.
 */
import {
  ShoppingCart,
  LifeBuoy,
  HelpCircle,
  HardDrive,
  Bell,
  type LucideIcon,
} from "lucide-react";
import type { AppNotification } from "@/lib/appNotifications";

export function notificationIcon(n: Pick<AppNotification, "kind">): LucideIcon {
  switch (n.kind) {
    case "order":
      return ShoppingCart;
    case "support":
      return LifeBuoy;
    case "enquiry":
      return HelpCircle;
    case "system":
      return HardDrive;
    default:
      return Bell;
  }
}
